export default __webpack_public_path__ + "static/media/user.dfe98d18.svg";